export default "<gabarito-header></gabarito-header>\n<router-outlet></router-outlet>\n<!-- <gabarito-footer></gabarito-footer> -->\n\n"